import { h } from 'vue';
import vhPaginate from './vh-paginate';

export default {
    // functional: true,

    props:
    {
        page: Object,
    },

    render()
    {
        return h(
            'div',
            [
                // h(
                //     vhPaginationDesktop,
                //     {
                //         page: this.page,
    
                //         customClass: 'vh-visible@m',
                //     },
                // ),
                // h(
                //     vhPaginationMobile,
                //     {
                //         page: this.page,
    
                //         customClass: 'vh-hidden@m',
                //     },
                // ),
                h(
                    vhPaginate,
                    {
                        page: this.page,

                    },
                ),
                
            ]
        );
        // const nodes = [
            
        // ];

        // return nodes;
    },
};
